import styled from 'styled-components';

export const SectionRow = styled.div`
	margin: 1rem 0;
`;

export const InputGroup = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 1.5rem;

	label {
		font-weight: 600;
		margin-bottom: 0.5rem;
		color: #333;
		font-size: 14px;
	}

	${props => props.markRequired && `
		label::after {
			content: ' *';
			color: #e74c3c;
		}
	`}
`;

export const Instructions = styled.div`
	background-color: #f8f9fa;
	border: 1px solid #e9ecef;
	border-radius: 4px;
	padding: 1rem;
	margin-bottom: 1.5rem;
	line-height: 1.6;
	font-size: 14px;
	color: #495057;
`;

export const TopInstructions = styled.div`
	background-color: #e3f2fd;
	border: 1px solid #bbdefb;
	border-radius: 8px;
	padding: 1.5rem;
	margin-bottom: 1.5rem;
	line-height: 1.8;
	font-size: 14px;
	color:rgb(0, 0, 0);

	p {
		margin: 0.5rem 0;
		&:first-child {
			margin-top: 0;
		}
		&:last-child {
			margin-bottom: 0;
		}
	}
`;

export const FurtherInstructions = styled.div`
	background-color: #ffffff;
	border: 1px solid #e0e0e0;
	border-radius: 8px;
	padding: 1.5rem;
	margin: 1.5rem 0;
	line-height: 1.6;
	font-size: 14px;
	color: #333333;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	ul {
		margin: 0.5rem 0;
		padding-left: 1.5rem;
	}

	ol {
		margin: 0.5rem 0;
		padding-left: 1.5rem;
	}

	li {
		margin-bottom: 0.5rem;
	}
`;

export const RulesHeading = styled.div`
	margin: 1.5rem 0 0.5rem 0;
	font-size: 16px;
`;

export const Rules = styled.div`
	background-color: #fff3cd;
	border: 1px solid #ffeaa7;
	border-radius: 4px;
	padding: 1rem;
	margin-bottom: 1rem;
`;

export const RuleList = styled.ul`
	margin: 0;
	padding-left: 1.5rem;
	line-height: 1.6;
	font-size: 14px;
	color: #856404;

	li {
		margin-bottom: 0.5rem;
	}
`;
